
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import DispatchOrdersTable from "@/components/order/DispatchOrdersTable.vue";
import { ORDER_MENU_ITEM, SEARCH_ORDER_SETTINGS } from "@/consts";
import OrderActions from "@/components/order/OrderActions.vue";
import notifications from "../lib/notifications";
import { DISPATCH_SHORTCUT } from "@/consts";
import { consolidateLoadsModal } from "@/lib/modals";

const orderModule = getModule(OrderModule);

@Component({
  components: { DispatchOrdersTable, OrderActions }
})
export default class SearchResults extends Vue {
  ORDER_MENU_ITEM: any = ORDER_MENU_ITEM;
  searchOrderSettings: any = SEARCH_ORDER_SETTINGS;
  showOrderFieldFilter: boolean = false;
  shortcuts: any = DISPATCH_SHORTCUT;

  get searchResults() {
    return orderModule.data;
  }
  created() {
    if (!this.searchResults) this.$router.push({ path: "/dispatch" });
  }

  get menuItemsToDisplay() {
    return this.ORDER_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission )  || this.hasPermission(x.requiresAgentPermission )
    );
  }

  async loadMoreOrders() {
    try {
      await orderModule.loadAdvancedSearch({ quickSearch: true });
    } catch (ex) {
      notifications.error("Order List", "Failed to load additional orders", ex);
    }
  }

  async onSort(s) {
    try {
      orderModule.applySearchSort(s);
    } catch (ex) {
      notifications.error("Search Results", "Failed to load search results", ex);
    }
  }

  async onFilter() {
    await this.reloadDispatchBoard();
  }

  async reloadDispatchBoard() {
    try {
      await orderModule.reloadOrders();
    } catch (ex) {
      notifications.error("Order List", "Failed to load orders", ex);
    }
  }

  exportOrders() {
    return orderModule.exportQuickSearchOrders();
  }
}
